import { render, staticRenderFns } from "./MiniBetslip.vue?vue&type=template&id=001e8df5"
import script from "./MiniBetslip.vue?vue&type=script&lang=js"
export * from "./MiniBetslip.vue?vue&type=script&lang=js"
import style0 from "./MiniBetslip.vue?vue&type=style&index=0&id=001e8df5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports